import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ValidateForm from '../forms/validate-form';
import { validateValidationSchema } from '../schema/validate.js';

export default function ValidateNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Validate Node Details',
        altText: 'Validate Node',
        defaultLabel: data?.command || 'Validate Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={ValidateForm} schemaResolver={validateValidationSchema} />
    </NodeProvider>
  );
}
